module.exports = __webpack_public_path__ + "img/118.a0e6bbc4.svg";